<template>
  <div class="form-elements">
    <div class="row">
      <div class="flex xs12">
        <va-card :title="$t('forms.inputs.product')">
          <form @submit.prevent>
            <div class="row">
              <div class="flex md4 sm6 xs12">
                <va-input
                  v-model="productsParams.name"
                  value="productsParams.name"
                  :label="$t('forms.inputs.nameProduct')"
                  removable
                >
                </va-input>
              </div>

              <div class="flex md4 sm6 xs12">
                <va-input
                  v-model="productsParams.address"
                  value="productsParams.address"
                  :label="$t('forms.inputs.address')"
                  removable
                />
              </div>

              <div class="flex md4 xs12">
                <va-select
                  :label="$t('forms.selects.selectProductGroup')"
                  v-model="productsParams.product_group_id"
                  keyBy="id"
                  textBy="name"
                  :options="listProductGroups"
                  searchable
                />
              </div>

              <div class="flex md4 xs12">
                <va-select
                  :label="$t('forms.selects.selectFragility')"
                  v-model="productsParams.fragility_id"
                  keyBy="id"
                  textBy="name"
                  :options="listFragilities"
                  searchable
                />
              </div>

              <div class="flex md4 xs12">
                <va-select
                  :label="$t('forms.selects.selectPackageLine')"
                  v-model="productsParams.product_line_id"
                  keyBy="id"
                  textBy="name"
                  :options="listProductLines"
                  searchable
                />
              </div>

              <div class="flex md4 sm6 xs12">
                <va-select
                  v-model="productsParams.product_family_id"
                  :label="$t('forms.inputs.productFamily')"
                  keyBy="id"
                  textBy="name"
                  :options="listProductFamilies"
                  searchable
                />
              </div>

              <div class="flex md4 sm6 xs12">
                <va-input
                  v-model="productsParams.ean"
                  value="productsParams.ean"
                  :label="$t('forms.inputs.ean')"
                  removable
                />
              </div>

              <div class="flex md4 sm6 xs12">
                <va-input
                  v-model="productsParams.integration_id"
                  value="productsParams.integration_id"
                  :label="$t('forms.inputs.integration_id')"
                  removable
                />
              </div>
              <div class="flex md4 sm6 xs12">
                <va-select
                v-model="productsParams.package_id"
                  :label="$t('forms.inputs.package')"
                  keyBy="id"
                  textBy="name"
                  :options="listPackages"
                  searchable
                />
              </div>

              <div class="flex md4 sm6 xs12">
                <va-select
                v-model="productsParams.product_type_id"
                  :label="$t('forms.inputs.product_type')"
                  keyBy="id"
                  textBy="name"
                  :options="listProductTypes"
                  searchable
                />
              </div>

            </div>
          <!-- upload image with crop -->
          <va-card>
            <template slot="header">
              <va-icon name="fa fa-image mr-3" color="greenLight"/>
              <p>{{ $t('forms.images.imageProduct') }}</p>
            </template>
            <div class="row">
              <div class="flex md6 sm6 xs12">
                <Cropper
                  :src="image"
                  @change="onChange"
                  :stencil-props="{
                    minAspectRatio: 8/8,
                    maxAspectRatio: 10/8
                  }"
                />
                <div class="flex md6 sm6 xs12">
                  <span class="button" @click="$refs.file.click()">
                    <input type="file" ref="file" @change="uploadImage($event)" accept=".jpg, .jpeg, .png">
                      {{ $t('forms.inputs.uploadImage') }}
                  </span>

                  <va-button
                    v-if="image_url"
                    small
                    :color="this.$themes.secondary"
                    icon="fa fa-close"
                    class="mr-1"
                    @click="showModalRemove = true, codeProduct = productsParams.productId"
                  >

                  {{$t('buttons.removeImage')}}
                  </va-button>

                  <div class="row">
                    <img v-if="image_url" :src="image_url" class="imageCropped"/>
                    <img v-else src="../../../assets/images/not-image.png" class="imageCropped" :style="display"/>
                  </div>

                </div>
              </div>

            </div>

            <va-modal
              v-model="showModalRemove"
              size="small"
              :title="$t('modal.remove')"
              :message="$t('modal.messageRemoveImage')"
              hideDefaultActions
              :color="this.$themes.secondary"
            >
              <va-button
                color="danger"
                class="ma-2"
                @click="showModalRemove = false">
                {{$t('modal.cancel')}}
              </va-button>

              <va-button
                color="secondary"
                class="ma-2"
                @click="removeImage(codeProduct), showModalRemove = false">
                {{$t('modal.confirm')}}
              </va-button>
            </va-modal>


          </va-card>
          <div class="row">
            <div class="flex md2 sm6 xs12">
              <va-button
                v-if="productsParams.productId == ''"
                medium
                inline
                color="secondary"
                icon="fa fa-save"
                class="ma-0"
                @click="save(productsParams)"
              >
                {{ $t('menu.save') }}
              </va-button>
              <va-button
                v-else
                medium
                inline
                color="secondary"
                icon="fa fa-save"
                class="ma-0"
                @click="update(productsParams)"
              >
                {{ $t('menu.update') }}
              </va-button>
            </div>

            <div class="flex md3 sm6 xs12">
              <va-button
                v-if="productsParams.productId == ''"
                medium
                inline
                color="secondary"
                icon="fa fa-save"
                class="ma-0"
                @click="create(productsParams)"
              >
                {{ $t('menu.saveNew') }}
              </va-button>
            </div>
            <div class="flex md4 sm6 xs12">
              <va-button
                medium
                inline
                color="#ff842b"
                icon="fa fa-chevron-left"
                class="ma-0"
                :to="{ name: 'products', params: {
                    current_page: this.$route.params.current_page,
                    searchName: this.$route.params.searchName,
                    perPage: this.$route.params.perPage }
                    }"
              >
                {{ $t('menu.back') }}
              </va-button>
            </div>
          </div>
        </form>
        </va-card>
      </div>
    </div>
  </div>
</template>

<script>

import ProductAPI from '@/services/ProductAPI'
import PackageAPI from '@/services/PackageAPI'
import FragilityAPI from '@/services/FragilityAPI'
import ProductLineAPI from '@/services/ProductLineAPI'
import ProductFamilyAPI from '@/services/ProductFamilyAPI'
import ProductGroupAPI from '@/services/ProductGroupAPI'
import { Cropper } from 'vue-advanced-cropper'
import { showError } from '@/global'

export default {
  name: 'form-products',
  props: ['img'],
	components: {
    Cropper,
	},
  data () {
    return {
      productsParams: {
        productId: '',
        name: '',
        address: '',
        ean: '',
        package_id: '',
        fragility_id: '',
        product_line_id: '',
        integration_id: '',
        product_family_id: '',
        product_group_id: '',
        product_type_id: '',
        image_params: {},
        coordinates: {
          width: 0,
          height: 0,
          left: 0,
          top: 0
        },
      },
      packageName: '',
      listPackages: [],
      listFragilities: [],
      listProductLines: [],
      listProductFamilies: [],
      listProductGroups: [],
      listProductTypes: [],
      image: null,
      image_url: '',
      picture: '',
      display: "",
      showModalRemove: false,
    }
  },
  mounted() {
    PackageAPI.getAllPackages().then(response => {
      this.listPackages = response.data.packages
    })

    FragilityAPI.getAllFragilities().then(response => {
      this.listFragilities = response.data.fragilities
    })

    ProductLineAPI.getAllProductLines().then(response => {
      this.listProductLines = response.data.product_lines
    })

    ProductFamilyAPI.getAllProductFamilies().then(response => {
      this.listProductFamilies = response.data.product_families
    })

    ProductGroupAPI.getAllProductGroups().then(response => {
      this.listProductGroups = response.data.product_groups
    })

    ProductAPI.getAllProductTypes().then(response => {
      this.listProductTypes = response.data.product_types
    })

    if (this.$route.params.id != undefined) {
      ProductAPI.getProductById(this.$route.params.id).then(response => {
        let res = response.data.product

        this.image_url = res.image
        this.productsParams.productId = res.id
        this.productsParams.name = res.name
        this.productsParams.address = res.address
        this.productsParams.ean = res.ean
        this.productsParams.integration_id = res.integration_id

        if (res.package != null) {
          this.productsParams.package_id = res.package.name
        }

        if (res.product_type != null) {
          this.productsParams.product_type_id = res.product_type.name
        }

        if (res.fragility != null) {
          this.productsParams.fragility_id = res.fragility.name
        }

        if (res.product_line != null) {
          this.productsParams.product_line_id = res.product_line.name
        }

        if (res.product_family!= null) {
          this.productsParams.product_family_id = res.product_family.name
        }

        if (res.product_group != null) {
          this.productsParams.product_group_id = res.product_group.name
        }

      })
    }
  },
  watch: {
  },
  methods: {
    uploadImage(event) {
			var input = event.target;
      var fileTypes = ['jpg', 'jpeg', 'png'];

			if (input.files && input.files[0]) {
        var extension = input.files[0].name.split('.').pop().toLowerCase()
        var isSuccess = fileTypes.indexOf(extension) > -1;

        if(isSuccess){
          var reader = new FileReader();
          reader.onload = (e) => {
            this.image = e.target.result;
            this.display = "display: none"
          }
          reader.readAsDataURL(input.files[0]);
          this.productsParams.image_params = event.target.files[0];
        }
        else{
          this.showToast(this.$t('toast.invalidFileFormat'), {
            icon: 'fa-thumbs-o-down',
            position: 'top-right',
            duration: 5000,
          })
        }
      }
    },

		onChange({coordinates, canvas}) {
			this.productsParams.coordinates = coordinates
    },

    save (productsParams) {
      ProductAPI.createProduct(productsParams).then(response => {
        this.product = response.data;

        this.showToast(response.data.message, {
          icon: 'fa-thumbs-o-up',
          position: 'top-right',
          duration: 5000,
        })

        this.$router.push({name: 'products',
          params: {
            id: productsParams.productId,
            current_page: this.$route.params.current_page,
            perPage: this.$route.params.perPage
          }
        })
      }).catch(e => {
          this.showToast(e.response.data.error, {
            icon: 'fa-thumbs-o-down',
            position: 'top-right',
            duration: 5000,
          })
      });
    },

    create (productsParams) {
      ProductAPI.createProduct(productsParams).then(response => {
        this.product = response.data;

        this.showToast(response.data.message, {
          icon: 'fa-thumbs-o-up',
          position: 'top-right',
          duration: 5000,
        })
        this.productsParams.name = ""
        this.productsParams.address = ""
        this.productsParams.ean = ""
        this.productsParams.integration_id = ""
        this.productsParams.product_family_id = ""
        this.productsParams.package_id = ""
        this.productsParams.fragility_id = ""
        this.productsParams.product_Group_id = ""
        this.productsParams.product_type_id = ""
        this.detailPackage = {}
        this.image = ""
      }).catch(e => {
          this.showToast(e.response.data.error, {
            icon: 'fa-thumbs-o-down',
            position: 'top-right',
            duration: 5000,
          })
      });
    },

    update (productsParams) {
      ProductAPI.updateProduct(productsParams).then(response => {
        this.product = response.data;

        this.showToast(response.data.message, {
          icon: 'fa-thumbs-o-up',
          position: 'top-right',
          duration: 5000,
        })

        this.$router.push({name: 'products',
          params: {
            id: productsParams.productId,
            current_page: this.$route.params.current_page,
            perPage: this.$route.params.perPage
            }
          })
      }).catch(e => {
          this.showToast(e.response.data.error, {
            icon: 'fa-thumbs-o-down',
            position: 'top-right',
            duration: 5000,
          })
      });
    },

    removeImage(productId) {
      this.image_url = ""

      ProductAPI.removeImage(productId).then(response => {
        this.showToast(response.data.message, {
          icon: 'fa-thumbs-o-up',
          position: 'top-right',
          duration: 5000,
        })

        this.$router.push({name: 'show-product',
          params: {
            id: this.productsParams.productId,
            current_page: this.$route.params.current_page,
            perPage: this.$route.params.perPage
            }
          })

      }).catch(e => {
          this.showToast(e.response.data.error, {
            icon: 'fa-thumbs-o-down',
            position: 'top-right',
            duration: 5000,
          })
      });
    }
  }
}
</script>

<style>
  .row.row-inside {
    max-width: none;
  }

  p {
    color: red;
    font-size: 10px;
    font-weight: bold;
    text-transform: uppercase;
  }

  .button {
    color: white;
    font-size: 14px;
    padding: 5px 10px;
    background: #000000;
    cursor: pointer;
    transition: background 0.5s;
    border-radius: 30px;
  }

  .button:hover {
    background: #000000;
  }

  .button input {
    display: none;
  }

  .imageCropped {
    margin-top: 20px;
    border-radius: 15px;
  }
</style>
